import { useCallback, useState } from 'react'
import { LLMResponse, UserLLMPromptPostParams } from '~/interfaces/llm'
import { postUserLLMPrompt } from '~/services/llm'

const NOT_LOADING = false
const LOADING = true

export const usePostUserLLMPrompt = ({
  onSuccess,
  onError
}: {
  onSuccess: (data: LLMResponse) => void
  onError: VoidFunction
}) => {
  const [data, setData] = useState<LLMResponse>({} as LLMResponse) // TODO: inicializar com um null object pattern

  const [isLoading, setIsLoading] = useState<boolean>(NOT_LOADING)
  const startLoading = () => setIsLoading(LOADING)
  const stopLoading = () => setIsLoading(NOT_LOADING)

  const [error, setError] = useState<Error>({} as Error) // TODO: inicializar com um null object pattern
  const cleanupError = () => setError({} as Error) // TODO: criar um null object pattern
  const updateError = (error: Error) => setError(error)

  const run = useCallback(
    ({ body, header }: UserLLMPromptPostParams) => {
      cleanupError()
      startLoading()
      postUserLLMPrompt({ body, header })
        .then(data => {
          setData(data)
          onSuccess(data)
        })
        .catch(error => {
          updateError(error)
          onError()
        })
        .finally(stopLoading)
    },
    [onError, onSuccess]
  )

  return { data, isLoading, error, run }
}
